import styled, { css } from 'styled-components';
const ASIDE_WIDTH = 250;
export const Container = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-500);
`;
export const Inner = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  gap: var(--space-500);
  position: relative;
  overflow: hidden;
`;
export const Content = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-500);
  will-change: width;
  transition: width 0.3s ease-out;

  ${({ hasAside }) => hasAside &&
    css `
      width: calc(100% - ${ASIDE_WIDTH}px - var(--space-500));
    `}
`;
export const Aside = styled.div `
  width: ${ASIDE_WIDTH}px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  will-change: transform;
  transform: translateX(${({ visible }) => (visible ? '0' : '100%')});
  transition: transform 0.3s ease-out;
`;
